import { FC } from 'react'
import AvailableModuleForm from './AvailableModuleForm'
import { CreateNewModuleProps } from './AvailableModule.d'

const CreateNewModule: FC<CreateNewModuleProps> = ({
    btnLabel,
    btnVariant,
    btnClassName,
}) => {
    return (
        <AvailableModuleForm
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Module created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create module',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating module...',
                },
                triggerBtnLabel: btnLabel,
                triggerBtnVariant: btnVariant,
                triggerBtnClassName: btnClassName,
            }}
        />
    )
}

export default CreateNewModule
